import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Box, Typography } from '@material-ui/core'
import { minDesktopScreenWidth } from 'src/utils/breakpoints'
import { postgraduatePromoBannerLenovo } from 'src/assets/images'
import BreadcrumbsComponent from 'src/components/BreadcrumbsComponent/BreadcrumbsComponent'
import InfoBox from 'src/components/PostGraduationContent/PostgraduateComponents/InfoBox/InfoBox'
import Tabs from 'src/components/PostGraduationContent/PostGraduationDetails/Tabs/PostGraduationTabs'
import Tab from 'src/components/PostGraduationContent/PostGraduationDetails/Tabs/PostGraduationTab'
import useMedia from 'src/hooks/useMedia'
import IntroductionTab from './IntroductionTab'
import InformationTab from './InformationTab'
import DisciplinesTab from './DisciplinesTab'
import SelectionTab from './SelectionTab'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { useStyles } from './PostGraduate2022Content.styles'

const PostGraduationDetailsContent = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  const { width } = useMedia()
  const { id } = useParams<{ id: string }>()

  const boxes = [
    'Presencial',
    '528 h/aulas,</br> 33 créditos',
    'Período de 22</br> meses',
    'Aulas iniciam</br> dia 02/05/2022'
  ]
  return (
    <Box className={globalClasses.containerPages}>
      <BreadcrumbsComponent
        crumbs={[
          { label: t('navbar.start'), path: '/' },
          { label: t('navbar.postgraduate'), path: '/postgraduate' },
          { label: 'Residência em Segurança Cibernética 2022' }
        ]}
      />
      <Box className={classes.container}>
        <Typography className={globalClasses.titleSectionVariant2}>
          Residência em Segurança Cibernética 2022
        </Typography>
        <Box className={classes.contentWrapper}>
          <Box className={classes.header}>
            {width >= minDesktopScreenWidth ? (
              <InfoBox boxes={boxes} />
            ) : (
              <>
                <InfoBox boxes={boxes.slice(0, 2)} />
                <InfoBox boxes={boxes.slice(2)} />
              </>
            )}
            <img
              className={classes.promoImg}
              src={postgraduatePromoBannerLenovo}
              alt="Promo banner UFC Lenovo"
            />
          </Box>
          <Tabs>
            <Tab title="Apresentação">
              <IntroductionTab />
            </Tab>
            <Tab title="Formato">
              <InformationTab />
            </Tab>
            <Tab title="Disciplinas">
              <DisciplinesTab />
            </Tab>
            <Tab title="Seleção">
              <SelectionTab />
            </Tab>
          </Tabs>
        </Box>
      </Box>
    </Box>
  )
}

export default PostGraduationDetailsContent
